import {
  AllocationResultDataSourceData,
  ProcessAllWaitlistsStats,
} from "@timeedit/registration-schemas";

export const severityTypeMap = {
  success: "Success",
  info: "Info",
  error: "Error",
  warning: "Warning",
} as const;

type NoticeType = keyof typeof severityTypeMap;
export type CapitalizedNoticeType = (typeof severityTypeMap)[NoticeType];

export interface ProcessWaitlistsResultNoticeState {
  type: NoticeType;
  title: string;
  stats?: ProcessAllWaitlistsStats;
}

export interface AllocationResultNoticeState {
  type: NoticeType;
  title: string;
  issuesData: AllocationResultDataSourceData[];
}

export interface NotificationState {
  type: NoticeType;
  title: string;
  description?: string;
  technicalInfo?: string;
}

export interface MessageState {
  type: NoticeType;
  content: string;
  duration?: number;
}
